import React from 'react';
import './IndexLeftPoint.scss';
const IndexLeftPoint = () => (
    <div className='indexLeftPoint'>

    </div>
)

export default IndexLeftPoint;